import { getEnvVar } from '@egr/xbox/utils/ReactScriptHelper';

import { ServiceProvider } from '@easterngraphics/pcon-services';

export const pConServiceProvider = new ServiceProvider(getEnvVar('X_PCON_SERVICES', 'default'));